<template>
<div class="container">
    <van-cell-group>
        <van-field icon="question" v-model="name" required label="收货人" placeholder="请输入收货人" clearable />
        <van-field icon="question" type="tel" required v-model="phone" label="手机号" placeholder="请输入手机号" clearable maxlength="11" />
        <van-field icon="question" readonly required v-model="city" clickable label="城市" :value="city" placeholder="选择城市" @click="showPicker = true" />
        <van-popup v-model="showPicker" round position="bottom">
            <van-area icon="question" title="选择地址" required ref="cascaderAddr" :area-list="options" @cancel="showPicker = false" @confirm="onConfirm" :columns-placeholder="['请选择', '请选择', '请选择']" />
        </van-popup>
        <van-field icon="question" show-word-limit v-model="address" label="详细地址" maxlength="100" required placeholder="请输入详细地址" clearable />
    </van-cell-group>
    <div class="button">
        <van-button round color="var(--theme-color-main)" size="large" @click="submit()" class="del-but">确认修改</van-button>
        <div class="info"><van-icon name="info-o" />仅支持于次日10时前修改收货地址</div>
    </div>
</div>
</template>

<script>
import {
    searchUserAddrList,
    deleteUserAddr,
    sysUserProvince,
    mOrderModReceLogSave,
    sysUserProvinceListAll,
    listSameCityArea,
    sysUserCityListAll, 
    sysUserAreaListAll,
} from "../../../api/api";
export default {
    data() {
        return {
            type: this.$route.query.type, //新增还是修改
            region: [],
            showPicker: false, //展示城市
            phone: this.$route.query.phone, //手机号
            name: this.$route.query.name, //用户名
            city: this.$route.query.city, //城市
            address: this.$route.query.address, //详细地址
            checked: null, //
            options: {
                province_list: {},
                city_list: {},
                county_list: {},
            },
            sameCityArea: {}, // 【省直辖县】市县相同对象
            sameCityAreaKeys: [], // 【省直辖县】市县相同对象
            specialAreas: [], // 特殊的区域
            id: this.$route.query.id,
            goodsId: this.$route.query.goodsId,
            goodsNum: this.$route.query.goodsNum,
            couponId: this.$route.query.couponId,
            formUrl: this.$route.query.formUrl, // 来源地址
        };
    },
    methods: {
        onConfirm(value) {
            // if (value[2] == undefined) {
            //     this.$toast("请选择");
            //     return;
            // }
            // console.log("value",value)
            if ((value[0].code == "" && value[0].name == "") || (value[0].code == null && value[0].name == null)) {
              this.$toast("请选择完整地区~");
              return;
            }

            if ((value[1].code == "" && value[1].name == "") || (value[1].code == null && value[1].name == null)) {
              this.$toast("请选择完整地区~");
              return;
            }
            if ((value[2].code == "" && value[2].name == "") || (value[2].code == null && value[2].name == null)) {
              this.$toast("请选择完整地区~");
              return;
            }
          // 选中市
          let selectedCity = value[1];
          // 选中县
          let selectedCounty = value[2];
          // 如果选中的县是省直辖县，就格式化一下选中的市
          if (Object.keys(this.sameCityArea).length > 0
              && (Object.keys(this.sameCityArea).indexOf(selectedCounty.code) > -1)) {
              value[1] =  selectedCounty;
          }
          // 如果选中的市是特殊的区域里面的话，就格式化一下选中的县
          if (this.specialAreas.length > 0 && this.specialAreas.indexOf(selectedCity.code) > -1) {
              value[2] =  value[1];
          }
            this.region = value;
            this.city = value[0].name + "-" + value[1].name + "-" + value[2].name;
            this.showPicker = false;
            // console.log(this.city);
            // console.log(this.region);
        },

        //获取省市区列表
        async sysUserProvince() {
            let params = {};
            const res = await sysUserProvince(params);
            if (res.code === "0000") {
                let temp = res.data;
                //省市格式
                for (let i = 0; i < temp.length; i++) {
                    this.options.province_list[temp[i].value] = temp[i].label;
                }

                //地级市格式
                for (let i = 0; i < temp.length; i++) {
                    for (let j = 0; j < temp[i].children.length; j++) {
                        this.options.city_list[temp[i].children[j].value] =
                            temp[i].children[j].label;
                    }
                }

                //区格式
                for (let i = 0; i < temp.length; i++) {
                    for (let j = 0; j < temp[i].children.length; j++) {
                        for (let k = 0; k < temp[i].children[j].children.length; k++) {
                            this.options.county_list[temp[i].children[j].children[k].value] =
                                temp[i].children[j].children[k].label;
                        }
                    }
                }
            } else {
                this.$toast(res.msg);
            }
        },
        // 省列表
        async sysUserProvinceListAll() {
          let params = {};
          const res = await sysUserProvinceListAll(params);
          if (res.code === "0000") {
            let temp = res.data;
            //省格式
            for (let i = 0; i < temp.length; i++) {
              this.options.province_list[temp[i].regionCode] = temp[i].regionName;
            }
          }
        },
        // 市列表
        async sysUserCityListAll(){
          let params = {};
          let this_ = this;
          const resSame = await listSameCityArea(params);
          if (resSame.code === "0000") {
            let sameKes = this_.sameCityAreaKeys;
            let sameData = resSame.data;
            // 市格式
            for (let i = 0; i < sameData.length; i++) {
              let sameCode = sameData[i].regionCode;
              let sameName = sameData[i].regionName
              let codeSub = sameCode.slice(0,3);
              let keyValue = {};
              keyValue[sameCode] = sameName;
              if(Object.keys(sameKes).indexOf(codeSub)<0){
                sameKes[codeSub]=[];
                sameKes[codeSub].push(keyValue);
              }else {
                sameKes[codeSub].push(keyValue);
              }
              this_.sameCityArea[sameCode] = sameName;
            }
            // 特殊县区
            if(this_.sameCityAreaKeys.length>0){
              Object.keys(this_.sameCityAreaKeys).forEach(function(key){
                if(this_.sameCityAreaKeys[key].length===1 && Object.keys(this_.sameCityAreaKeys[key][0]).length>0){
                  this_.specialAreas.push(Object.keys(this_.sameCityAreaKeys[key][0])[0]);
                }
              });
            }
          }
          const res = await sysUserCityListAll(params);
          if (res.code === "0000") {
            let temp = res.data;
            //市格式
            for (let i = 0; i <temp.length; i++) {
              let regionCode = temp[i].regionCode;
              let regionCodeSub = regionCode.slice(0,3);
              if(Object.keys(this_.sameCityAreaKeys).indexOf(regionCodeSub)<0){
                this_.options.city_list[regionCode] = temp[i].regionName;
              }else {
                // 省直辖县处理
                if(this_.sameCityAreaKeys[regionCodeSub].length>1){
                  this_.options.city_list[regionCodeSub.concat("0","0","0")] = "省直辖县";
                }else {
                  this_.options.city_list[regionCode] = temp[i].regionName;
                }
              }
            }
          }
        },
        // 区列表
        async sysUserAreaListAll(){
          let params = {};
          let this_ = this;
          const res = await sysUserAreaListAll(params);
          if (res.code === "0000") {
            let temp = res.data;
            // 区格式
            for (let i = 0; i < temp.length; i++) {
              let areaCode = temp[i].regionCode;
              // 特殊区处理
              if(this_.specialAreas.length>0 && this_.specialAreas.indexOf(areaCode) > -1){
                // console.log('改造前',areaCode,temp[i].regionName)
                // 【注意】：这里的区code不是数据库里的，最后一个位置换成了1
                this_.options.county_list[areaCode.slice(0,5).concat("1")] = temp[i].regionName;
                // console.log('改造后',areaCode.slice(0,5).concat("1"),temp[i].regionName);
              }else {
                this_.options.county_list[areaCode] = temp[i].regionName;
              }
            }
          }
        },
      
        //修改
        async submit() {
            if (!this.name) {
                this.$toast("请输入收货人信息~");
                return;
            }
            if (!this.phone) {
                this.$toast("请输入联系方式信息~");
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                this.$toast("请输入正确的手机号");
                return;
            }

            if (this.region.length < 3) {
                this.$toast("请选择所在地区~");
                return;
            }
            // console.log(this.region);
            if (
                !this.region[0].name &&
                !this.region[1].name &&
                !this.region[1].name
            ) {
                this.$toast("请选择所在地区~");
                return;
            }
            if (!this.address) {
                this.$toast("请输入详细地址信息~");
                return;
            } else {
                let params = {
                    orderNo:this.$route.query.orderNo,
                    productId:this.$route.query.productId,
                    newReceiverName: this.name,
                    newReceiverPhone: this.phone,
                    newReceiverProvinceName: this.region[0].name,
                    newReceiverProvinceId: this.region[0].code,
                    newReceiverCityName: this.region[1].name,
                    newReceiverCityId: this.region[1].code,
                    newReceiverRegionName: this.region[2].name,
                    newReceiverCountryId: this.region[2].code,
                    newReceiverAddress: this.address,
                };
             

                let res = await mOrderModReceLogSave(params);
                if (res.code === "0000") {
                    if (this.$route.query.back == "order") {
                      this.$router.push({
                        path: "/order",
                      });
                    }else{
                      this.$router.go(-1);
                    }
                    
                } else {
                    this.$toast(res.msg);
                }
            }
        },
    },

    mounted() {
        // this.sysUserProvince();
        let regionList = this.$route.query.region.split(' ')
        this.region = [{
            name:regionList[1],
            code:regionList[0],
        },{name:regionList[3],
            code:regionList[2],},{name:regionList[5],
            code:regionList[4],}]
        console.log(this.region)
        this.sysUserProvinceListAll();
        this.sysUserCityListAll();
        this.sysUserAreaListAll();
        if (this.id) {
            this.getUserAddressById();
            // this.sysUserProvince();
            this.sysUserProvinceListAll();
            this.sysUserCityListAll();
            this.sysUserAreaListAll();
        }
    },
};
</script>

<style lang="scss" scoped>
.default-cell {
    margin-top: 21px;
}

.button {
    margin: 40px 85px 0;
}

.button-bottom {
    margin: 19px 85px;
}

.del-but {
    height: 88px;
}
.info{
    color:#999;
    text-align: center;
    margin-top: 10px;
}
</style>
